import { getPaths } from "2g-utils-sorter";
import {
  AnoNe,
  DateAktivita,
  DoplnkoveSluzby,
  Kolize,
  Termin,
  Zadavatel,
  ZadostStavLabel
} from "b2b/renderers";
import { Zdroj, Projekt } from "b2b/renderers/ciselnik";

export const datumPosledniAktivity = () => ({
  id: "datumPosledniAktivity",
  label: "b2b.zadosti-grid-columns.posledniAktivita.label",
  path: "datumPosledniAktivity",
  renderer: DateAktivita
});

export const doplnkoveSluzby = () => ({
  id: "doplnkoveSluzby",
  label: "b2b.zadosti-grid-columns.doplnkoveSluzby.label",
  path: "doplnkoveSluzby",
  renderer: DoplnkoveSluzby
});

export const projektNazev = () => ({
  id: "projektNazev",
  label: "b2b.zadosti-grid-columns.projekt.label",
  path: "projekt",
  renderer: Projekt
});

export const termin = () => ({
  id: "termin",
  label: "b2b.zadosti-grid-columns.termin.label",
  renderer: Termin,
  sorter: getPaths(["datumOd", "datumDo"])
});

export const zadavatelZakaznikNazev = () => ({
  id: "zakaznik",
  label: "b2b.zadosti-grid-columns.zadavatel.label",
  path: "zadavatel",
  renderer: Zadavatel
});

export const zdrojNazev = () => ({
  id: "nazev",
  label: "b2b.zadosti-grid-columns.zdroj.label",
  path: "zdroj",
  renderer: Zdroj
});

export const kolize = () => ({
  id: "kolize",
  label: "b2b.zadosti-grid-columns.kolize.label",
  path: "kolize",
  renderer: Kolize
});

export const fixni = () => ({
  id: "fixni",
  label: "b2b.zadosti-grid-columns.fixni.label",
  path: "fixni",
  renderer: AnoNe
});

export const datumVytvoreni = () => ({
  id: "datumVytvoreni",
  label: "b2b.zadosti-grid-columns.datum-vytvoreni.label",
  path: "datumVytvoreni",
  renderer: DateAktivita
});

export const stav = () => ({
  id: "stav",
  label: "b2b.zadosti-grid-columns.stav.label",
  path: "stav",
  renderer: ZadostStavLabel
});
